// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2g1UC","errorLogs":"styles_errorLogs__3jp8Z"};